export default __webpack_public_path__ + "static/media/google_on_white.68f88d82.png";